@if (state() === 'up') {
	<span class="position-change-chip gain" aria-label="Position gained">
		<span class="position-change-arrow" aria-hidden="true">
			<svg viewBox="0 0 12 12" fill="currentColor" focusable="false">
				<path d="M6 2L10 8H2z"></path>
			</svg>
		</span>
	</span>
} @else if (state() === 'down') {
	<span class="position-change-chip loss" aria-label="Position lost">
		<span class="position-change-arrow" aria-hidden="true">
			<svg viewBox="0 0 12 12" fill="currentColor" focusable="false">
				<path d="M2 4h8L6 10z"></path>
			</svg>
		</span>
	</span>
}
